<template>
  <div class="page-header">
    <div class="row">
      <div class="col-lg-6">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li
              v-for="(item, index) in computedBreadcrumbs"
              :key="index"
              class="breadcrumb-item"
              :class="{ 'active': item.active }"
            >
              <router-link
                v-if="!item.active"
                :to="item.link"
              >
                {{ item.text }}
              </router-link>
              <span v-else>{{ item.text }}</span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'home'
    },
    main: {
      type: String,
      default: ''
    },
    mainLink: {
      type: String,
      default: 'welcome'
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    product: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    computedBreadcrumbs() {
      if (this.breadcrumbs.length > 0) {
        return this.breadcrumbs.map((item, index) => ({
          text: item.text,
          link: this.interpolate(item.link),
          active: item.active || index === this.breadcrumbs.length - 1
        }));
      } else {
        const crumbs = [];
        if (this.main) {
          crumbs.push({text: this.main, link: {name: this.mainLink}, active: false});
        }
        if (this.title) {
          crumbs.push({text: this.title, link: '', active: true});
        }
        return crumbs;
      }
    }
  },
  methods: {
    interpolate(link) {
      if (link.includes('${')) {
        return link.replace(/\$\{([^\}]+)\}/g, (_, key) => {
          const keys = key.split('.');
          let value = this;
          keys.forEach(k => {
            value = value[k];
          });
          return value;
        });
      }
      // Check if link is a direct path
      return link.startsWith('/') ? { path: link } : { name: link };
    }
  }
}
</script>
